import { Auth } from 'aws-amplify';

const environment = {
    production: true,
    debug: false,
    offline: false,
    cloudformationLaunchStackUrl: 'https://console.aws.amazon.com/cloudformation/home?region=us-east-1#/stacks/create/review?stackName=VizCon&templateURL=https://vizcon-resources-prod.s3.amazonaws.com/iac/latest/crossAccountAccessRole.yml',
    cloudformationTemplateUrl: 'https://resources.vizcon.cloud/iac/latest/crossAccountAccessRole.yml',
    cognitoSelfSignUpEnabled: true,
    Amplify: {
        Auth: {
            region: 'PLACEHOLDER', // To be updated after Terraform deployment
            userPoolId: 'PLACEHOLDER',  // To be updated after Terraform deployment
            userPoolWebClientId: 'PLACEHOLDER',   // To be updated after Terraform deployment
        },
        API: {
            endpoints: [
                {
                    name: 'VizConAPI',
                    endpoint: 'https://api.PLACEHOLDER',  // To be updated with actual domain
                    custom_header: async () => {
                        return { Authorization: (await Auth.currentSession()).getIdToken().getJwtToken() };
                    }
                }
            ]
        }
    },
    features: {
        subscriptions: false,  // Disabled for enterprise deployment
        userInvitation: false
    },
    stripe: {
        enabled: false,  // Disabled for enterprise deployment
        "redirectUrl": ""  // To be updated with actual domain
    },
    aws: {
        enabled: false,  // Disabled for enterprise deployment
        marketplaceUrl: "",  // Disabled for enterprise deployment
        subscriptionManagementUrl: "",  // Disabled for enterprise deployment
        productCode: "",  // Disabled for enterprise deployment (Lifetime product code)
        productCodeSubscription: ""  // Disabled for enterprise deployment (Subscription product code)
    },
    defaultRoleName: "vizcon",
    matomo: {
        enabled: false,  // Disabled for enterprise deployment
        containerUrl: ""
    },
    branding: {
        logoPath: "assets/img/logo/customer-logo.png",  // To be customized with customer logo
        logoAlt: "Customer Logo",  // To be customized with customer company name
        companyName: "Customer Name"  // To be customized with customer company name
    },
    license: {
        expiryDate: null,  // Optional: ISO date string (e.g., "2024-12-31T23:59:59Z") for POC/trial licenses
        warningDays: 7     // Show warning X days before expiry
    }
};

export default environment;